export const _setSidebarSelectedStudent = (state, action) => {
  state.sideBarSelectedStudent = action.payload;
};

export const _addCompletedStudent = (state, action) => {
  const student = action.payload;

  // prevent duplicates
  if (!state.completedStudents.find((s) => s.id === student.id)) {
    state.completedStudents.push(student);
  }

  // remove from active list
  state.sideBarSelectedStudent = state.sideBarSelectedStudent.filter(
    (s) => s.id !== student.id
  );
};

export const _removeCompletedStudent = (state, action) => {
  const student = action.payload;

  // remove from completed
  state.completedStudents = state.completedStudents.filter(
    (s) => s.id !== student.id
  );

  // add back to active list
  state.sideBarSelectedStudent.push(student);
};
